import React from "react";
import { Hero, SavePatientSection } from "../../components";
import { heroData } from "../../assets/data/savePatientData";

export default function SaveAPatient() {
	return (
		<>
			<Hero data={heroData} />

			<SavePatientSection />
		</>
	);
}
